import { render, staticRenderFns } from "./CargoListPage.vue?vue&type=template&id=a230a602&scoped=true"
import script from "./CargoListPage.vue?vue&type=script&lang=js"
export * from "./CargoListPage.vue?vue&type=script&lang=js"
import style0 from "./CargoListPage.vue?vue&type=style&index=0&id=a230a602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a230a602",
  null
  
)

export default component.exports